import { useApolloClient } from '@apollo/client'
import clsx from 'clsx'
import React, { FC, useContext, useState } from 'react'

import SvgLetter from '@Assets/SVG/Letter'
import SvgPhone from '@Assets/SVG/Phone'
import { Link } from '@Components/Link'
import { NativeModal, NativeModalBody, NativeModalHeader, NativeModalProps } from '@Components/Modal/NativeModal/NativeModal'
import { BlockTypeWithGlobal, PageType } from '@Generated/graphql'
import { useBlockComponents } from '@Globals/CMS/useBlockComponents'
import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'
import { getSinglePostByID } from '@Queries/cms/SinglePost.query'
import { Spinner } from '@Shared/Components/Spinner/Spinner'

import styles from './styles.module.scss'

export interface ContactModalProps extends NativeModalProps {
}

const showOpeningHours = false
const showPhone = true

/**
 * Do not import this component directly, but instead trigger it via "useCMSOpenModal"
 *
 * const openModal = useCMSOpenModal()
 * openModal(PageType.Modal, 'contact-us')
 */
export const ContactModal: FC<ContactModalProps> = (props) => {
  const { t } = useTranslation()
  const {
    store,
  } = useContext(MetadataContext)
  const storeEmail = store?.config?.email
  const phone = store?.config?.phone || ''
  const client = useApolloClient()
  const [tabBlocks, setTabBlocks] = useState<BlockTypeWithGlobal[]>([])
  const [loading, setLoading] = useState(true)
  const components = useBlockComponents(tabBlocks || [])

  return (
    <NativeModal
      {...props}
      alignment="right"
      backdrop
      className={clsx(styles.contactModal, props?.className)}
      onOpen={() => {
        getSinglePostByID(client, PageType.Landingpage, '2316').then((res) => {
          setTabBlocks((res?.data?.page?.blocks as (undefined | BlockTypeWithGlobal[]))?.slice(0, 2) || [])
          setLoading(false)
        })
      }}
    >
      <NativeModalHeader>
        {t('footer:FOOTER_CONTACT_TITLE')}
      </NativeModalHeader>
      <NativeModalBody>
        {showOpeningHours && <span className={styles.openingHours}>{t('footer:FOOTER_CONTACT_PHONES_ARE_OPEN_BETWEEN')}</span>}
        <span className={styles.contactInfo}>
          <Link
            analytics={{
              dest_page_type: 'contact',
              dest_page_type_id: '',
              source_id: 'footer_contact_us',
            }}
            href={`mailto:${storeEmail}`}
          >
            <SvgLetter />
            {storeEmail}
          </Link>
          {showPhone && (
            <a href={`tel:${phone.replace(' ', '')}`}>
              <SvgPhone />
              <span>
                {phone}
              </span>
            </a>
          )}
        </span>
        <div className={styles.faqSection}>
          {loading && <Spinner />}
          {!loading && components}

        </div>
      </NativeModalBody>
    </NativeModal>
  )
}
